import {
  SET_MAIS_DETALHES_FIELD,
  LOADING_MAIS_DETALHES,
  ERROR_MAIS_DETALHES
} from './types';

const initialState = {
  formMaisDetalhes: {
    maisDetalhes_field: ''
  },
  loadingMaisDetalhes: false,
  errorMaisDetalhes: null
}

export default function maisDetalhesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MAIS_DETALHES_FIELD:
      return { ...state, formMaisDetalhes: { ...state.formMaisDetalhes, maisDetalhes_field: action.payload } }
    case LOADING_MAIS_DETALHES:
      return { ...state, loadingMaisDetalhes: action.payload }
    case ERROR_MAIS_DETALHES:
      return { ...state, errorMaisDetalhes: action.payload }
    default:
      return state
  }
}
